export default __webpack_public_path__ + "static/george-lamb-530d2acd13e2f7b36f09bcf842249943.png";